import * as orderApi from '../../api/orderApi'

const state = {
    orderDetail: {},
    updateOrderLinkmanResult:{},
    updateScheduledTimeResult:{},
    updateOrderItemResult:{},
    receivingOrderResult:{},
    discardOrderResult:{},
    dismissedOrderResult:{},
    settlementOrderResult:{},
    verifyServiceCodeResult:{},
    initiatePaymentResult:{},
    takeMoneyReSendServiceCodeResult:{},
		fullScreenProductList: {},
		ActivateQAResult: {}
}

const getters = {
    CurrOrderDetail: (state, getters, rootState) => {
		return state.orderDetail;
	}
}

const actions = {
		async GetActivateQA({ commit }, params) {
				const response = await orderApi.GetActivateQA(params);
				commit('setActivateQAResult', response);
				return response;
		},
    async GetOrderDetail({ commit }, order) {
        const response = await orderApi.GetOrderDetail(order);
        commit('setOrderDetail', response);
        return response;
    },
    async UpdateOrderLinkman({ commit }, order) {
        const response = await orderApi.UpdateOrderLinkman(order)
        commit('setUpdateOrderLinkmanResult', response);
        return response;
    },
    async UpdateScheduledTime({ commit }, order) {
        const response = await orderApi.UpdateOrderScheduledTime(order)
        commit('setUpdateScheduledTimeResult', response);
        return response;
    },
    async UpdateOrderItem({ commit }, order) {
        const response = await orderApi.UpdateOrderItem(order);
        commit('setUpdateOrderItemResult', response);
        return response;
    },
    async ReceivingOrder({ commit }, order) {
        const response = await orderApi.ReceivingOrder(order);
        commit('setReceivingOrderResult', response);
        return response;
    },
    async DiscardOrder({ commit }, order) {
        const response = await orderApi.DiscardOrder(order);
        commit('setDiscardOrderResult', response);
        return response;
    },
    async DismissedOrder({ commit }, order) {
        const response = await orderApi.DismissedOrder(order);
        commit('setDismissedOrderResult', response);
        return response;
    },
    async SettlementOrder({ commit }, order) {
        const response = await orderApi.SettlementOrder(order);
        commit('setSettlementOrderResult', response);
        return response;
    },
    async VerifyServiceCode({ commit }, order) {
        const response = await orderApi.VerifyServiceCode(order);
        commit('setVerifyServiceCodeResult', response);
        return response;
    },
    async InitiatePayment({ commit }, order) {
        const response = await orderApi.InitiatePayment(order);
        commit('setInitiatePaymentResult', response);
        return response;
    },
    async TakeMoneyReSendServiceCode({ commit }, order) {
        const response = await orderApi.TakeMoneyReSendServiceCode(order);
        commit('setTakeMoneyReSendServiceCodeResult', response);
        return response;
    },
    async GetProductBySkuCode({ commit }, order) {
        const response = await orderApi.GetProductBySkuCode(order);
        commit('setGetProductBySkuCodeResult', response);
        return response;
    },
    async GetOneCode({ commit }, order) {
        const response = await orderApi.GetOneCode(order);
        return response;
    },
    async InsideCodeQueryQualityAssurance({ commit }, order) {
        const response = await orderApi.InsideCodeQueryQualityAssurance(order);
        return response;
    },
    async UpdateRepairRemark({ commit }, order) {
        const response = await orderApi.UpdateRepairRemark(order);
        return response;
    },
    //代修订单作废
    async DiscardAgentOrder({commit}, order){
        const response = await orderApi.DiscardAgentOrder(order);
        return response;
    },
		//无忧卡订单IMEI校验
		async CareOrderVervify({commit}, order){
			const response = await orderApi.CareOrderVervify(order);
			return response;
		},
    ClearData({commit}){
        commit('clearOrderDetail')
    }
  }

const mutations = {
		setActivateQAResult(state, data) {
				state.ActivateQAResult = data.Data;
		},
    setOrderDetail(state, data) {
        state.orderDetail = data.Data;
    },
    setUpdateOrderLinkmanResult(state, data){
        state.updateOrderLinkmanResult = data;
    },
    setUpdateScheduledTimeResult(state, data){
        state.updateScheduledTimeResult = data;
    },
    setUpdateOrderItemResult(state, data){
        state.updateOrderItemResult = data;
    },
    setReceivingOrderResult(state, data){
        state.receivingOrderResult = data;
    },
    setDiscardOrderResult(state, data){
        state.discardOrderResult = data;
    },
    setDismissedOrderResult(state, data){
        state.dismissedOrderResult = data;
    },
    setSettlementOrderResult(state, data){
        state.settlementOrderResult = data;
    },
    setVerifyServiceCodeResult(state, data){
        state.verifyServiceCodeResult = data;
    },
    setInitiatePaymentResult(state, data){
        state.initiatePaymentResult = data;
    },
    setTakeMoneyReSendServiceCodeResult(state, data){
        state.takeMoneyReSendServiceCodeResult = data;
    },
    setGetProductBySkuCodeResult(state, data){
        state.fullScreenProductList = data;
    },
    clearFullScreenProductList(state){
        state.fullScreenProductList = {};
    },
    clearOrderDetail(state){
        state.orderDetail = {};
    }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/orderdetail.js